import { _ } from "../../../polyglot/polyglot.js";
import { makeMonitorRepository } from "../../../repositories/repositoryBuilders.js";
import AbstractImporter from "../AbstractImporter.js";
import PowerOfficeGoIntegration from "../../../../models/integration/PowerOfficeGoIntegration.js";
import session from "../../../session.js";
import TokenStep from "../TokenStep.js";

const defaultErrorKey = "defaultError";

/**
 * `PowerOfficeGoImporter` Import wizard for PowerOfficeGo
 */
export default class PowerOfficeGoImporter extends AbstractImporter {
	constructor() {
		super(...arguments);

		this._powerOfficeGoRepository = makeMonitorRepository({
			route: "/Shared/Import/PowerOfficeGo",
			antiForgeryToken: session.getAntiForgeryToken(),
		});

		this._errorMessageByKey = this._makeErrorMessageByKey();
	}

	_wizardSteps() {
		return [this._clientKeyStep()];
	}

	// Step 1: let the user insert the client key if no existing integration
	_clientKeyStep() {
		return new TokenStep({
			label: _("PowerOffice Go Client key"),
			hasToken: () => this._context.company.hasPowerOfficeGoIntegration(),
			attribute: "clientKey",
			submitCallback: this._fetchData.bind(this),
		});
	}

	async _fetchData({ onDone, step }) {
		const model = { companyId: this._getCompanyId() };

		const clientKey = this._context.clientKey;
		if (clientKey) model.clientKey = clientKey;

		try {
			const data = await this._powerOfficeGoRepository.save({
				model,
				notify: false,
			});

			if (data.hasErrors) {
				step.addSubmitError(this._errorToMessage(data));
			}

			this._context.importData = data;
			onDone();
		} catch (error) {
			step.addSubmitError(error.responseJSON.message);
			onDone();
		}
	}

	_errorToMessage({ typeOfError }) {
		const errorMessage = this._errorMessageByKey[typeOfError];
		return errorMessage || this._errorMessageByKey[defaultErrorKey];
	}

	_makeErrorMessageByKey() {
		return {
			Authorization: _("The provided client key is not valid."),

			Connection: _(
				"There is a connection problem to PowerOffice Go servers.",
			),
			ApiException: _(
				"We are having problems with the import from {externalAPI}. It might just be a temporary problem so please try again in a few minutes or contact support if the problem remains.",
				{ externalAPI: "PowerOffice Go" },
			),

			[defaultErrorKey]: _(
				"An unidentifiable problem occurred while importing from PowerOffice Go.",
			),
		};
	}
}

PowerOfficeGoImporter.integrationType = PowerOfficeGoIntegration.getType();
